import React from "react";
import _ from "lodash";

export default class Video extends React.Component {
  constructor(props) {
    super(props);
    this._hideVideoControls = this._hideVideoControls.bind(this);
    this._showVideoControls = this._showVideoControls.bind(this);
    this._handleMetadata = this._handleMetadata.bind(this);
    this.video = React.createRef();
  }

  componentDidMount() {
    this.video.current.addEventListener("loadedmetadata", this._handleMetadata);
  }

  componentWillUnmount() {
    this.video.current.removeEventListener(
      "loadedmetadata",
      this._handleMetadata
    );
  }

  _handleMetadata() {
    const { handleVideoMetadata } = this.props;
    const guardedFn = _.isFunction(handleVideoMetadata)
      ? handleVideoMetadata
      : _.noop;
    guardedFn(this.video.current);
  }

  _hideVideoControls() {
    this.video.current.removeAttribute("controls");
  }

  _showVideoControls() {
    this.video.current.setAttribute("controls", true);
  }

  render() {
    const { src, thumbnailUri } = this.props;
    return (
      <video
        ref={this.video}
        style={{ display: "block", marginRight: "20px" }}
        src={src}
        preload="metadata"
        type="video/mp4"
        width="304px"
        height="171px"
        onMouseEnter={this._showVideoControls}
        onMouseLeave={this._hideVideoControls}
        poster={thumbnailUri}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Video.js